module.exports = __webpack_public_path__ + "static/media/dobyvatel.757d8515.png";